import {
  EAffinitySource,
  EEnrichmentMode,
  EEnrichmentStatus,
  EProductGender,
  EProductSeason,
  EProductStyle,
  ERecommendationReason
} from "../recommendation.types";

export * from "./enums";

export const DEFAULT_RECOMMENDATION_LIMIT = 10;
export const ENRICHMENT_PAGE_SIZE = 25;
export const AFFINITY_MIN_WEIGHT = 1;
export const AFFINITY_MAX_WEIGHT = 3;

export const AFFINITY_SOURCE_LABELS: Record<EAffinitySource, string> = {
  [EAffinitySource.Manual]: "Manual",
  [EAffinitySource.Ai]: "AI",
  [EAffinitySource.Learned]: "Learned"
};

export const AFFINITY_SOURCE_COLORS: Record<EAffinitySource, string> = {
  [EAffinitySource.Manual]: "#FB3973",
  [EAffinitySource.Ai]: "#4A6CF7",
  [EAffinitySource.Learned]: "#16C350"
};

export const RECOMMENDATION_REASON_LABELS: Record<
  ERecommendationReason,
  string
> = {
  [ERecommendationReason.BoughtTogether]: "Bought together",
  [ERecommendationReason.Affinity]: "Goes with",
  [ERecommendationReason.SameCategory]: "Same category",
  [ERecommendationReason.BestSeller]: "Best seller",
  [ERecommendationReason.NewArrival]: "New arrival",
  [ERecommendationReason.RecentSearch]: "Recent search",
  [ERecommendationReason.PopularNearby]: "Popular nearby",
  [ERecommendationReason.Discovery]: "Discovery"
};

export const RECOMMENDATION_REASON_COLORS: Record<
  ERecommendationReason,
  string
> = {
  [ERecommendationReason.BoughtTogether]: "#16C350",
  [ERecommendationReason.Affinity]: "#FB3973",
  [ERecommendationReason.SameCategory]: "#4A6CF7",
  [ERecommendationReason.BestSeller]: "#FF9900",
  [ERecommendationReason.NewArrival]: "#8E5CF7",
  [ERecommendationReason.RecentSearch]: "#00A6A6",
  [ERecommendationReason.PopularNearby]: "#E8590C",
  [ERecommendationReason.Discovery]: "#8E8E93"
};

export const ENRICHMENT_STATUS_LABELS: Record<EEnrichmentStatus, string> = {
  [EEnrichmentStatus.Pending]: "Pending",
  [EEnrichmentStatus.Enriched]: "Enriched",
  [EEnrichmentStatus.Failed]: "Failed",
  [EEnrichmentStatus.Skipped]: "Skipped"
};

/** Row status in the coverage list, including "none" (never attempted). */
export const ENRICHMENT_LIST_STATUS_LABELS: Record<string, string> = {
  enriched: "Enriched",
  pending: "Pending",
  failed: "Failed",
  skipped: "Skipped",
  none: "Not enriched"
};

export const ENRICHMENT_LIST_STATUS_COLORS: Record<string, string> = {
  enriched: "#16C350",
  pending: "#FF9900",
  failed: "#FF0033",
  skipped: "#8E8E93",
  none: "#8E8E93"
};

export const PRODUCT_GENDER_LABELS: Record<EProductGender, string> = {
  [EProductGender.Women]: "Women",
  [EProductGender.Men]: "Men",
  [EProductGender.Unisex]: "Unisex",
  [EProductGender.Kids]: "Kids",
  [EProductGender.Unknown]: "Unknown"
};

export const PRODUCT_SEASON_LABELS: Record<EProductSeason, string> = {
  [EProductSeason.Spring]: "Spring",
  [EProductSeason.Summer]: "Summer",
  [EProductSeason.Autumn]: "Autumn",
  [EProductSeason.Winter]: "Winter",
  [EProductSeason.AllSeason]: "All season",
  [EProductSeason.Unknown]: "Unknown"
};

export const ENRICHMENT_MODE_LABELS: Record<EEnrichmentMode, string> = {
  [EEnrichmentMode.None]: "Don't tag",
  [EEnrichmentMode.Vision]: "Read the photo",
  [EEnrichmentMode.Text]: "Read name + description"
};

export const ENRICHMENT_MODE_COLORS: Record<EEnrichmentMode, string> = {
  [EEnrichmentMode.None]: "#8E8E93",
  [EEnrichmentMode.Vision]: "#4A6CF7",
  [EEnrichmentMode.Text]: "#8E5CF7"
};

export const PRODUCT_STYLE_LABELS: Record<EProductStyle, string> = {
  [EProductStyle.Casual]: "Casual",
  [EProductStyle.Formal]: "Formal",
  [EProductStyle.Traditional]: "Traditional",
  [EProductStyle.Sporty]: "Sporty",
  [EProductStyle.Elegant]: "Elegant",
  [EProductStyle.Streetwear]: "Streetwear"
};

/** The general attribute set — the picker's "no schema" option. */
export const GENERAL_PROFILE_KEY = "general";
